import { render, staticRenderFns } from "./TributeHeader.vue?vue&type=template&id=482f8650"
import script from "./TributeHeader.vue?vue&type=script&lang=js"
export * from "./TributeHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports